import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DisputeStorageService } from '../../services/create-dispute-storage.service';
import { BansStorageService } from '../../services/bans-storage.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-create-dispute',
  templateUrl: './create-dispute.component.html',
  styleUrls: ['./create-dispute.component.css'],
})

export class CreateDisputeComponent implements OnInit {
  invoiceData: any;
  infovalue: any = 20;
  summaryvalue: any = 0;
  confirmvalue: any = 0;
  selectedSection: string = 'invoice-info';
  isInvoiceDispute: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bansService: BansStorageService,
    private disputeStorageService: DisputeStorageService
  ) { }

  ngOnInit(): void {
    let disputeType = localStorage.getItem('dispute-type') || ''
    this.isInvoiceDispute = (disputeType == 'invoice-level-dispute') ? true : false;

    if (this.router.url == "/invoices/create-dispute/invoice-info") {
      this.selectedSection = 'invoice-info';
    }
    else {
      this.selectedSection = 'dispute-summary';
    }
    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        if (event.url == "/invoices/create-dispute/invoice-info") {
          this.selectedSection = 'invoice-info';
        }
        else {
          this.selectedSection = 'dispute-summary';
        }
      });

    this.invoiceData = localStorage.getItem('selected-invoice-to-dispute') || '';
    this.invoiceData = this.invoiceData && JSON.parse(this.invoiceData);
  
    this.disputeStorageService.infovalue.subscribe((progress) => {
      this.infovalue = progress;
    });

    this.disputeStorageService.summaryvalue.subscribe((summary) => {
      this.summaryvalue = summary;
    });

    this.disputeStorageService.confirmationvalue.subscribe((confirmation) => {
      this.confirmvalue = confirmation;
    });
  }

  goback() {
    if (this.router.url == '/invoices/create-dispute/invoice-info') {
      if (this.isInvoiceDispute) {
        this.checkTsaBanAndNavigate();
      }
      else {
        this.router.navigate(["/invoices"]);
        this.removeLocalStorageData();
      }
    }
    else {
      this.selectedSection = 'invoice-info';
      this.router.navigate(["/invoices/create-dispute/invoice-info"], { relativeTo: this.route.parent });
    }
  }

  selectDisputeSection(event: any) {
    this.selectedSection = event;
    if (this.selectedSection == 'invoice-info') {
      this.router.navigate(["/invoices/create-dispute/invoice-info"], { relativeTo: this.route.parent });
    }
    else {
      this.router.navigate(["/invoices/create-dispute/dispute-summary"], { relativeTo: this.route.parent });
    }
  }

  checkTsaBanAndNavigate() {
    let bansForTSA: any = [];
    this.bansService.bansTSA.subscribe((bansTSA: any) => {
      if (bansTSA) {
        bansForTSA = bansTSA;
      }
    })
    let filteredBAN = bansForTSA.filter((element: any) => {
      const elementBpNo = element.bancust.toString().replace(/^0+/, '');
      const itemBpNo = this.invoiceData.bpNo.toString().replace(/^0+/, '');
      return (element.bancust == this.invoiceData.bpNo || elementBpNo == itemBpNo);
    });
    this.removeLocalStorageData();
    if (filteredBAN[0] && filteredBAN[0].isTSA) {
      this.router.navigate([`/invoices/view-tsa-invoice/${this.invoiceData.invoice_id}`], { relativeTo: this.route, state: { invoice: this.invoiceData } });
    }
    else {
      this.router.navigate([`/invoices/view-invoice/${this.invoiceData.invoice_id}`], { relativeTo: this.route, state: { invoice: this.invoiceData } });
    }
  }

  ngOnDestroy(): void {
    this.removeLocalStorageData();
  }

  removeLocalStorageData() {
    localStorage.removeItem('selected-invoice-to-dispute');
    localStorage.removeItem('selected-item-to-dispute');
    localStorage.removeItem('selected-type-to-dispute')
    localStorage.removeItem('ban-data-to-dispute');
    localStorage.removeItem('dispute-type');
    this.disputeStorageService.resetStore();
  }

}